import {SectionCard, SectionValueBox} from "base/ui/section/components";

const EntityCommentsSection = ({
    comments,
    title = "Observações",
    displayCard = false,
}) => {
    return displayCard ? (
        <SectionCard title={title}>
            <SectionValueBox value={comments} />
        </SectionCard>
    ) : (
        <SectionValueBox value={comments} />
    );
};

export default EntityCommentsSection;
